import {
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Flex,
  Typography,
  message,
  Select,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const EditModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const typeValue = Form.useWatch("type", form);
  useImperativeHandle(ref, () => ({
    open: async (record) => {
      setCurrentRecord(record);
      form.resetFields();
      form.setFieldsValue({
        type: record.type,
        workYears: record.workYears,
        annualHours: record.annualHours,
        remark: record.remark,
      });

      setVisible(true);
    },
  }));
  const LEAVE_TYPE_OPTIONS = [
    { value: 1, label: "Annual Leave" },
    { value: 2, label: "Sick Leave" },
  ];
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const queryParams = {
        ...values,
        id: currentRecord?.id,
      };
      const response = await http.post(api.getRuleUpdate, queryParams);
      if (response?.code === "1") {
        message.success("Update successfully.");

        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(response?.msg);
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            EDIT ANNUAL LEAVE
          </Typography.Title>
        </Flex>
      }
      width="60%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="createBankForm"
              layout="horizontal"
              labelCol={{ style: { width: "200px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex justify="space-between" align="flex-start">
                <div style={{ flex: 1 }}>
                  {currentRecord?.type !== 2 && (
                    <Form.Item
                      name="workYears"
                      label="Work Years"
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                         disabled
                        style={{ width: "100%" }}
                        placeholder="Please enter work years."
                        min={0}
                        precision={0}
                        controls={false}
                      />
                    </Form.Item>
                  )}
                  <Form.Item
                    name="annualHours"
                    label="Annual Hours"
                    rules={[{ required: true }]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="Please enter annual hours."
                      min={0}
                      precision={0}
                      controls={false}
                    />
                  </Form.Item>
                  <Form.Item
                    name="type"
                    label="Leave Type"
                    rules={[
                      { required: true, message: "Please select leave type." },
                    ]}
                  >
                    <Select
                      options={LEAVE_TYPE_OPTIONS}
                      placeholder="Please select leave type"
                      disabled
                    />
                  </Form.Item>
                  <Form.Item name="remark" label="Remark">
                    <Input
                      style={{ width: "100%" }}
                      placeholder="Please enter remark."
                    />
                  </Form.Item>
                </div>
              </Flex>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default EditModal;
